/* Kit v4 · «Así funciona tu recarga» animada (sections/kit4-recarga-anim.liquid).
   Una película de ~70 s en un escenario de 400×500 que se escala al ancho: hoy compras tu kit → pasan los meses →
   aviso 4 días antes → entras en tu recarga → cambias una mezcla → cambias la fecha → pausas → y así cada 3 meses.
   Usa las mezclas que la clienta ha elegido en la ficha (evento `k4:sel`) y fechas reales contadas desde hoy.
   Cada elemento lleva UNA animación (Web Animations) que dura toda la película y solo toca transform/opacity:
   así se puede reproducir, pausar y saltar a una escena moviendo el reloj de todas a la vez, y el iPhone no repinta.
   Arranca al verse, se pausa fuera de pantalla y al acabar se queda quieta en el último plano. */
(function () {
  'use strict';
  if (window.__k4rjs) return; window.__k4rjs = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ED = !!(window.Shopify && Shopify.designMode);
  var OUT = 'cubic-bezier(.16,1,.3,1)', IO = 'cubic-bezier(.65,0,.35,1)', SOFT = 'cubic-bezier(.33,1,.68,1)',
    SHEET = 'cubic-bezier(.32,.72,0,1)', DOWN = 'cubic-bezier(.45,0,.85,.35)', LIN = 'linear';
  var MES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var MES3 = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  var DIA = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] }) }
  function fill(t, o) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m }) }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €' }
  function addM(d, n) { var y = d.getFullYear(), m = d.getMonth() + n, last = new Date(y, m + 1, 0).getDate(); return new Date(y, m, Math.min(d.getDate(), last)) }
  function addD(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n) }
  function big(u, w) { return u ? String(u).replace(/([?&]width=)\d+/, '$1' + (w || 600)) : '' }
  function y_(names) { return names.length < 2 ? names.join('') : names.slice(0, -1).join(', ') + ' y ' + names[names.length - 1] }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1) }

  /* ---------- reloj: una animación por elemento a lo largo de toda la película ---------- */
  function TL(T) { this.T = T; this.m = new Map() }
  TL.prototype.init = function (el, st) {
    if (!el) return this;
    var r = this.m.get(el); if (!r) { r = { st: { x: 0, y: 0, s: 1, sx: 1, r: 0, o: 1 }, seg: [] }; this.m.set(el, r) }
    Object.assign(r.st, st); return this;
  };
  TL.prototype.to = function (el, t, d, st, e) { if (!el) return this; this.init(el, {}); this.m.get(el).seg.push({ t: t, d: d, st: st, e: e || OUT }); return this };
  function kcss(s, off) { return { offset: off, transform: 'translate(' + s.x.toFixed(2) + 'px,' + s.y.toFixed(2) + 'px) rotate(' + s.r + 'deg) scale(' + (s.s * s.sx).toFixed(4) + ',' + s.s.toFixed(4) + ')', opacity: s.o } }
  TL.prototype.build = function () {
    var T = this.T, out = [];
    this.m.forEach(function (r, el) {
      var cur = Object.assign({}, r.st), kf = [kcss(cur, 0)], last = 0;
      r.seg.sort(function (a, b) { return a.t - b.t }).forEach(function (g) {
        var t = Math.max(g.t, last), e = Math.min(T, t + g.d), a = kcss(cur, t / T);
        a.easing = g.e; kf.push(a); cur = Object.assign({}, cur, g.st); kf.push(kcss(cur, e / T)); last = e;
      });
      kf.push(kcss(cur, 1));
      var an = el.animate(kf, { duration: T, fill: 'both' }); an.pause(); out.push(an);
    });
    return out;
  };

  /* ---------- fechas reales desde hoy ---------- */
  function dates() {
    var hoy = new Date(); hoy = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
    var rec = addM(hoy, 3), av = addD(rec, -4), dim = new Date(rec.getFullYear(), rec.getMonth() + 1, 0).getDate();
    var nd = rec.getDate() + 14 <= dim ? rec.getDate() + 14 : (rec.getDate() + 7 <= dim ? rec.getDate() + 7 : rec.getDate() - 7);
    return { hoy: hoy, m1: addM(hoy, 1), m2: addM(hoy, 2), rec: rec, av: av, nueva: new Date(rec.getFullYear(), rec.getMonth(), nd) };
  }
  function largo(d) { return d.getDate() + ' de ' + MES[d.getMonth()] }

  /* ---------- piezas del escenario ---------- */
  function page(band, num, sub, r, big_) { return '<div class="rc-cal' + (big_ ? ' is-hoy' : '') + '" data-r="' + r + '"><div class="mo">' + esc(band) + '</div><div class="dd">' + esc(num) + '</div><div class="wd">' + esc(sub) + '</div></div>' }
  function card(m, r, w, lvl, note) {
    return '<figure class="rc-mc' + (w < 70 ? ' is-sm' : '') + '" data-r="' + r + '" style="width:' + w + 'px"><span class="ph-i"><img src="' + esc(big(m.img, 500)) + '" alt="" loading="lazy" decoding="async"></span><span class="rnm">' + esc(m.n) + '</span>' +
      (lvl ? '<span class="lvl" data-r="' + r + '-l"><i data-r="' + r + '-f"></i></span><small data-r="' + r + '-q">' + esc(note) + '</small>' : '') + '</figure>';
  }
  function thumb(m) { return '<img src="' + esc(big(m.img, 160)) + '" alt="" loading="lazy" decoding="async">' }

  function Film(root, cfg) {
    this.root = root; this.cfg = cfg; this.st = root.querySelector('[data-rc-stage]'); this.subs = root.querySelector('[data-rc-subs]');
    this.anims = []; this.raf = 0; this.playing = false; this.done = false; this.seen = false; this.vis = false;
    var D = null; try { var j = document.querySelector('[data-k4-data]'); if (j) D = JSON.parse(j.textContent) } catch (e) { }
    this.D = D || cfg.demo || { mz: [], ship: 0, recFree: 0 };
    this.MZ = (this.D.mz || []).filter(function (m) { return m.id && m.a !== false && m.sp !== null && m.sp !== false });
  }

  Film.prototype.pick = function (handles) {
    var by = {}, MZ = this.MZ; MZ.forEach(function (m) { by[m.k] = m });
    var sel = (handles || []).filter(function (k) { return by[k] }).map(function (k) { return by[k] });
    if (sel.length < 2) sel = MZ.filter(function (m) { return m.dh }).slice(0, 2);
    if (sel.length < 2) sel = MZ.slice(0, 2);
    var used = sel.map(function (m) { return m.k }), pref = this.cfg.nueva;
    var nw = by[pref] && used.indexOf(pref) < 0 ? by[pref] : MZ.filter(function (m) { return used.indexOf(m.k) < 0 })[0];
    return { sel: sel, old: sel[sel.length - 1], nw: nw };
  };
  Film.prototype.rec = function (list) {
    var D = this.D, s = list.reduce(function (a, m) { return a + (m.spp || m.p || 0) }, 0);
    var free = D.recFree > 0 && s >= D.recFree; return s + (free ? 0 : (D.ship || 0));
  };

  Film.prototype.build = function (handles) {
    var c = this.cfg, t = c.t, P = this.pick(handles), sel = P.sel, old = P.old, nw = P.nw, n = sel.length;
    if (!nw) return false;
    var d = dates(), after = sel.slice(0, -1).concat([nw]);
    var name = c.nombre || '', names = sel.map(function (m) { return m.n });
    var V = { nombre: esc(name), antes: esc(old.n), nueva: esc(nw.n), mezclas: esc(y_(names)), fecha: largo(d.rec), nueva_fecha: largo(d.nueva),
      aviso: DIA[d.av.getDay()] + ' ' + d.av.getDate(), dia: DIA[d.rec.getDay()] + ' ' + d.rec.getDate() };
    var p0 = this.rec(sel), p1 = this.rec(after);

    /* --- escenario --- */
    var cw = n > 2 ? 60 : 86, cg = n > 2 ? 8 : 12, cx0 = 392 - (n * cw + (n - 1) * cg), CY = 238;
    var h = '';
    h += '<img class="rc-w" data-r="w1" src="' + esc(c.img.w1) + '" alt="" style="left:42px;top:30px;height:440px">';
    h += '<img class="rc-w" data-r="w2" src="' + esc(c.img.w2) + '" alt="" style="left:8px;top:168px;height:300px">';
    h += '<img class="rc-w" data-r="w3" src="' + esc(c.img.w3) + '" alt="" style="left:22px;top:36px;height:440px">';
    h += '<img class="rc-w" data-r="w4" src="' + esc(c.img.w4) + '" alt="" style="left:46px;top:30px;height:440px">';
    /* taco de calendario: la hoja de hoy encima, debajo los meses que pasan y el día del aviso */
    h += '<div class="rc-pad" style="left:230px;top:64px">' +
      page(MES3[d.av.getMonth()], d.av.getDate(), DIA[d.av.getDay()], 'pav') +
      page(MES3[d.m2.getMonth()], d.m2.getDate(), DIA[d.m2.getDay()], 'pm2') +
      page(MES3[d.m1.getMonth()], d.m1.getDate(), DIA[d.m1.getDay()], 'pm1') +
      page(DIA[d.hoy.getDay()].toUpperCase(), t.hoy, '', 'phoy', 1) + '</div>';
    sel.forEach(function (m, i) { h += '<div class="rc-at" style="left:' + (cx0 + i * (cw + cg)) + 'px;top:' + CY + 'px">' + card(m, 'c' + i, cw, 1, t.queda) + '</div>' });
    after.forEach(function (m, i) { h += '<div class="rc-at" style="left:' + (cx0 + i * (cw + cg)) + 'px;top:' + (n > 2 ? 150 : 104) + 'px">' + card(m, 'e' + i, cw) + '</div>' });
    /* próximas recargas (final) */
    var mths = [0, 3, 6, 9].map(function (k) { return addM(d.rec, k) });
    mths.forEach(function (dt, j) {
      h += '<div class="rc-chip" data-r="k' + j + '" style="left:' + Math.round(200 + j * 49.33) + 'px;top:' + (n > 2 ? 290 : 300) + 'px"><b>' + MES3[dt.getMonth()] + '</b><span>' + after.map(function (m) { return thumb(m) }).join('') + '</span></div>';
    });
    /* cambio fuera del móvil */
    h += '<div class="rc-at" style="left:130px;top:150px">' + card(old, 'bo', 124) + '</div>';
    h += '<svg class="rc-arrow" data-r="ar" viewBox="0 0 80 40" style="left:158px;top:268px" aria-hidden="true"><path d="M4 28 C 26 6, 52 6, 72 22"/><path d="M62 22 L73 23 L69 12"/></svg>';
    h += '<div class="rc-at" style="left:236px;top:140px">' + card(nw, 'bn', 140) + '</div>';
    /* el móvil */
    var rows = sel.map(function (m, i) {
      var last = i == n - 1;
      return '<div class="slot"' + (last ? ' data-r="slot"' : '') + '><div class="rw"' + (last ? ' data-r="rwo"' : '') + '>' + thumb(m) + '<b>' + esc(m.n) + '</b><span class="rpill"' + (last ? ' data-r="pillB"' : '') + '>' + esc(t.cambiar) + '</span></div>' +
        (last ? '<i class="hl" data-r="hl"></i><div class="rw" data-r="rwn">' + thumb(nw) + '<b>' + esc(nw.n) + '</b><span class="rpill done">✓ ' + esc(t.cambiada) + '</span></div>' : '') + '</div>';
    }).join('');
    var tiles = this.MZ.filter(function (m) { return m.k != old.k }).slice(0, 6).map(function (m) {
      var has = sel.some(function (x) { return x.k == m.k }), isN = m.k == nw.k;
      return '<div class="tile' + (has ? ' has' : '') + '"' + (isN ? ' data-r="tileN"' : '') + '>' + (isN ? '<i class="tsel" data-r="tsel"></i>' : '') + thumb(m) + '<b>' + esc(m.n) + '</b>' + (has ? '<small>' + esc(t.tienes) + '</small>' : '') + (isN ? '<span class="ck" data-r="ck">✓</span>' : '') + '</div>';
    }).join('');
    var dm = new Date(d.rec.getFullYear(), d.rec.getMonth() + 1, 0).getDate(), off = (new Date(d.rec.getFullYear(), d.rec.getMonth(), 1).getDay() + 6) % 7, days = '';
    for (var i = 0; i < off; i++) days += '<span></span>';
    for (var k = 1; k <= dm; k++) days += '<span' + (k == d.rec.getDate() ? ' class="dcur"' : '') + (k == d.nueva.getDate() ? ' data-r="dN"' : '') + '><i class="ddot"' + (k == d.nueva.getDate() ? ' data-r="dsel"' : '') + '></i><em>' + k + '</em>' + (k == d.nueva.getDate() ? '<em class="w" data-r="dnum">' + k + '</em>' : '') + '</span>';
    var sb = '<div class="sb"><span>9:41</span><span class="bt"><i></i><i></i><i></i><i class="bat"></i></span></div>';
    var home = sb + '<div class="app"><div class="brand">' + esc(t.marca) + '</div><p class="hi" data-r="h1">' + fill(esc(t.hola), V) + '</p>' +
      '<div class="dc" data-r="h2"><div class="v" data-r="dc0"><span class="l">' + esc(t.proxima) + '</span><span class="d">' + V.fecha + '</span><span class="pw"><span class="p" data-r="pr0">' + esc(fill(t.llega, { precio: eur(p0) })) + '</span>' +
      (p1 != p0 ? '<span class="p p2" data-r="pr1">' + esc(fill(t.llega, { precio: eur(p1) })) + '</span>' : '') + '</span></div>' +
      '<div class="v" data-r="dc1"><span class="l">' + esc(t.proxima) + '</span><span class="d">' + V.nueva_fecha + '</span><span class="p">' + esc(fill(t.llega, { precio: eur(p1) })) + '</span></div>' +
      '<div class="v" data-r="dc2"><span class="pz"><i></i>' + esc(t.pausada) + '</span><span class="pt">' + esc(t.pausada_txt) + '</span></div></div>' +
      '<div class="lb" data-r="h3">' + esc(t.tus) + '</div><div class="rows" data-r="h4">' + rows + '</div>' +
      '<div class="btns" data-r="h5"><span data-r="bF">' + esc(t.fecha) + '</span><span data-r="bP">' + esc(t.pausar) + '</span><span class="solid" data-r="bR">' + esc(t.reanudar) + '</span></div>' +
      '<div class="cancel" data-r="h6">' + esc(t.cancelar) + '</div></div>';
    var lock = '<div class="lock" data-r="lock"><div class="tm">9:41</div><div class="dt">' + cap(DIA[d.av.getDay()]) + ', ' + largo(d.av) + '</div></div>';
    var sheets = '<div class="dim" data-r="dim"></div>' +
      '<div class="sheet" data-r="shS"><h4>' + fill(esc(t.cual), V) + '</h4><div class="list">' + tiles + '</div></div>' +
      '<div class="sheet" data-r="shD"><h4>' + esc(t.dia) + '</h4><div class="mon"><span>‹</span>' + MES[d.rec.getMonth()] + ' ' + d.rec.getFullYear() + '<span>›</span></div><div class="wk"><span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span></div><div class="days">' + days + '</div><div class="go" data-r="go">' + fill(esc(t.guardar), V) + '</div></div>' +
      '<div class="toast" data-r="tS"><i>✓</i>' + fill(esc(t.toast_cambio), V) + '</div>' +
      '<div class="toast" data-r="tP"><i>✓</i>' + esc(t.toast_pausa) + '</div>' +
      '<span class="tap" data-r="tap"></span>';
    h += '<div class="ph" data-r="ph"><div class="scr" data-r="scr">' + lock + '<div class="home" data-r="home">' + home + '</div>' + sheets + '</div></div>';
    h += '<div class="rnoti" data-r="noti"><span class="nic"></span><div><div class="h"><span>' + esc(t.noti_de) + '</span><span>' + esc(t.noti_hora) + '</span></div><b>' + esc(t.noti_titulo) + '</b><p>' + fill(esc(t.noti_texto), V) + '</p></div></div>';
    h += '<div class="rc-fade" data-r="fade"></div>';

    this.st.innerHTML = '<div class="rc-sc" data-r="sc">' + h + '</div>';
    var S = this.subs.querySelector('[data-rc-sublist]');
    S.innerHTML = c.subs.map(function (s, i) { return '<p data-r="s' + i + '">' + fill(esc(s), V) + '</p>' }).join('');

    var R = {}; this.root.querySelectorAll('[data-r]').forEach(function (e) { R[e.getAttribute('data-r')] = e });
    this.R = R; this.n = n; this.after = after;
    this.scale();
    this.timeline();
    return true;
  };

  Film.prototype.scale = function () {
    var w = this.st.clientWidth; if (this.R && this.R.sc) this.R.sc.style.transform = 'scale(' + (w / 400) + ')';
  };

  /* posición (centro) de un elemento dentro de la pantalla del móvil, sin transformaciones */
  function at(el, scr) {
    var x = el.offsetWidth / 2, y = el.offsetHeight / 2, e = el;
    while (e && e !== scr) { x += e.offsetLeft; y += e.offsetTop; e = e.offsetParent }
    return { x: x, y: y };
  }

  Film.prototype.timeline = function () {
    var R = this.R, n = this.n, tl = new TL(70000), scr = R.scr, self = this;
    if (this.anims.length) this.anims.forEach(function (a) { a.cancel() });
    var A = function (r) { return R[r] };
    var cards = [], ends = [], fills = [], notes = [], lvls = [];
    for (var i = 0; i < n; i++) { cards.push(A('c' + i)); ends.push(A('e' + i)); fills.push(A('c' + i + '-f')); notes.push(A('c' + i + '-q')); lvls.push(A('c' + i + '-l')) }

    /* cámara del móvil: arriba del todo o abajo, para ver las hojas */
    var bottom = A('h6').offsetTop + A('h6').offsetHeight + A('home').offsetTop;
    var TOP = Math.min(16, 482 - 9 - bottom), BOT = -100, PX = 55;
    var tapAt = function (el) { var p = at(el, scr); return { x: p.x - 19, y: p.y - 19 } };
    var sh = function (el) { return el.offsetHeight + 24 };

    /* estado inicial: todo escondido salvo el primer plano */
    ['w1', 'w2', 'w3', 'w4', 'phoy', 'pm1', 'pm2', 'pav', 'ar', 'noti', 'ph', 'dim', 'tS', 'tP', 'tap', 'ck', 'tsel', 'dsel', 'dnum', 'hl', 'rwn', 'dc1', 'dc2', 'bR', 'pr1', 'k0', 'k1', 'k2', 'k3', 'bo', 'bn']
      .forEach(function (r) { tl.init(A(r), { o: 0 }) });
    cards.concat(ends).forEach(function (e) { tl.init(e, { o: 0, y: 14 }) });
    notes.concat(lvls).forEach(function (e) { tl.init(e, { o: 0 }) });
    fills.forEach(function (e) { tl.init(e, { sx: 1 }) });
    tl.init(A('home'), { o: 0 }).init(A('lock'), { o: 1 });
    tl.init(A('ph'), { x: 186, y: 96, s: .72, o: 0 });
    tl.init(A('shS'), { y: sh(A('shS')) }).init(A('shD'), { y: sh(A('shD')) });
    tl.init(A('tS'), { o: 0, y: -16 }).init(A('tP'), { o: 0, y: -16 });
    tl.init(A('fade'), { o: 1 });

    /* subtítulos: uno por plano */
    var SUB = [300, 6800, 13300, 21300, 27000, 29300, 33600, 37800, 45300, 57000, 63800];
    SUB.forEach(function (t, i) {
      var e = A('s' + i); if (!e) return; tl.init(e, { o: 0, y: 6 }).to(e, t, 800, { o: 1, y: 0 }, OUT);
      if (i < SUB.length - 1) tl.to(e, SUB[i + 1] - 500, 450, { o: 0, y: -4 }, SOFT);
    });
    this.SUB = SUB;

    /* 1 · Hoy compras tu kit */
    tl.init(A('w1'), { y: 14 }).to(A('w1'), 400, 1500, { o: 1, y: 0 }, OUT);
    tl.init(A('phoy'), { y: 16, s: .97 }).to(A('phoy'), 1100, 1200, { o: 1, y: 0, s: 1 }, OUT);
    cards.forEach(function (e, i) { tl.to(e, 1800 + i * 240, 1100, { o: 1, y: 0 }, OUT) });

    /* 2 · Pasan los meses */
    tl.to(A('w1'), 6500, 900, { o: 0, y: -6 }, SOFT);
    tl.init(A('w2'), { y: 12 }).to(A('w2'), 6900, 1400, { o: 1, y: 0 }, OUT);
    ['pm1', 'pm2', 'pav'].forEach(function (r) { tl.to(A(r), 6600, 10, { o: 1 }, LIN) });
    [['phoy', 7900], ['pm1', 9100], ['pm2', 10300]].forEach(function (p) {
      tl.to(A(p[0]), p[1], 320, { y: -4, r: -1.5 }, SOFT).to(A(p[0]), p[1] + 320, 950, { y: 58, r: -11, o: 0 }, DOWN);
    });
    lvls.forEach(function (e) { tl.to(e, 6900, 900, { o: 1 }, SOFT) });
    fills.forEach(function (e, i) { tl.to(e, 7800, 4200, { sx: [.32, .18, .24][i] || .2 }, IO) });
    notes.forEach(function (e) { tl.to(e, 11200, 800, { o: 1 }, SOFT) });

    /* 3 · Te avisamos 4 días antes */
    tl.to(A('w2'), 13000, 800, { o: 0 }, SOFT);
    tl.to(A('pav'), 13000, 800, { o: 0, y: 8 }, SOFT);
    cards.forEach(function (e) { tl.to(e, 13000, 800, { o: 0, y: 8 }, SOFT) });
    tl.init(A('w3'), { y: 12 }).to(A('w3'), 13500, 1400, { o: 1, y: 0 }, OUT);
    tl.to(A('ph'), 13700, 1400, { o: 1, y: 70 }, OUT);
    [188.5, 183.5, 188.5, 186].forEach(function (x, i) { tl.to(A('ph'), 15300 + i * 90, 90, { x: x }, SOFT) });
    tl.init(A('noti'), { y: -14, s: .98 }).to(A('noti'), 15600, 1000, { o: 1, y: 0, s: 1 }, OUT);

    /* 4 · Entras en tu recarga: la cámara entra en su móvil */
    tl.to(A('noti'), 21000, 650, { o: 0, y: -8, s: .98 }, SOFT);
    tl.to(A('w3'), 21100, 1000, { o: 0, x: -20 }, SOFT);
    tl.to(A('ph'), 21200, 1700, { x: PX, y: TOP, s: 1 }, IO);
    tl.to(A('lock'), 21700, 600, { o: 0 }, SOFT).to(A('home'), 22200, 500, { o: 1 }, SOFT);
    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(function (r, i) { tl.init(A(r), { o: 0, y: 8 }).to(A(r), 22400 + i * 110, 1000, { o: 1, y: 0 }, OUT) });

    /* tocar: aparece el círculo, se hunde el botón y se va */
    function tap(t, el, press) {
      var p = tapAt(el);
      tl.to(A('tap'), t - 20, 10, { x: p.x, y: p.y, s: 1.25 }, LIN).to(A('tap'), t, 380, { o: 1, s: 1 }, OUT).to(A('tap'), t + 700, 420, { o: 0, s: .9 }, SOFT);
      if (press) tl.to(press, t + 420, 140, { s: .95 }, SOFT).to(press, t + 560, 320, { s: 1 }, OUT);
    }
    function sheetUp(t, el) {
      tl.to(A('fade'), t, 400, { o: 0 }, SOFT);
      tl.to(A('ph'), t, 1100, { y: BOT }, IO).to(A('dim'), t + 100, 600, { o: 1 }, SOFT).to(el, t + 200, 1000, { y: 0 }, SHEET);
    }
    function sheetDown(t, el) {
      tl.to(el, t, 700, { y: sh(el) }, 'cubic-bezier(.3,0,.8,.15)').to(A('dim'), t + 100, 600, { o: 0 }, SOFT).to(A('ph'), t + 200, 1100, { y: TOP }, IO);
      tl.to(A('fade'), t + 900, 500, { o: 1 }, SOFT);
    }

    /* 5 · Cambia de mezcla */
    tap(28000, A('pillB'), A('pillB'));
    sheetUp(29000, A('shS'));
    tap(30900, A('tileN'));
    tl.to(A('tsel'), 31350, 450, { o: 1 }, SOFT).init(A('ck'), { s: .4 }).to(A('ck'), 31400, 600, { o: 1, s: 1 }, OUT);
    sheetDown(32400, A('shS'));
    tl.to(A('rwo'), 33500, 550, { o: 0, x: -14 }, SOFT);
    tl.init(A('rwn'), { x: 16 }).to(A('rwn'), 33800, 900, { o: 1, x: 0 }, OUT);
    tl.to(A('hl'), 33700, 600, { o: 1 }, SOFT).to(A('hl'), 36200, 1000, { o: 0 }, SOFT);
    if (A('pr1')) tl.to(A('pr0'), 34200, 450, { o: 0 }, SOFT).to(A('pr1'), 34400, 700, { o: 1 }, SOFT);
    tl.to(A('tS'), 34200, 800, { o: 1, y: 0 }, OUT).to(A('tS'), 36800, 500, { o: 0, y: -10 }, SOFT);
    /* fuera del móvil: sale la vieja, entra la nueva */
    tl.to(A('ph'), 37400, 700, { o: 0, s: .95, x: PX + 145 * .05, y: TOP + 300 * .05 }, SOFT);
    tl.to(A('fade'), 37400, 600, { o: 0 }, SOFT);
    tl.init(A('bo'), { y: 10 }).to(A('bo'), 38200, 1000, { o: 1, y: 0 }, OUT).to(A('bo'), 39300, 1300, { x: -96, y: 40, r: -6, o: .38 }, IO);
    tl.init(A('ar'), { x: -8 }).to(A('ar'), 39900, 800, { o: 1, x: 0 }, OUT);
    tl.init(A('bn'), { x: 24, s: .97 }).to(A('bn'), 40200, 1200, { o: 1, x: 0, s: 1 }, OUT);

    /* 6 · Cambia la fecha */
    ['bo', 'ar', 'bn'].forEach(function (r) { tl.to(A(r), 45000, 700, { o: 0 }, SOFT) });
    tl.to(A('ph'), 45400, 1100, { o: 1, s: 1, x: PX, y: TOP }, OUT).to(A('fade'), 45600, 600, { o: 1 }, SOFT);
    tap(46700, A('bF'), A('bF'));
    sheetUp(47700, A('shD'));
    tap(49400, A('dN'));
    tl.init(A('dsel'), { s: .5 }).to(A('dsel'), 49850, 550, { o: 1, s: 1 }, OUT).to(A('dnum'), 49900, 400, { o: 1 }, SOFT);
    tap(51000, A('go'), A('go'));
    sheetDown(52000, A('shD'));
    tl.to(A('dc0'), 53300, 500, { o: 0, y: -6 }, SOFT);
    tl.init(A('dc1'), { y: 6 }).to(A('dc1'), 53500, 900, { o: 1, y: 0 }, OUT);

    /* 7 · Pausa */
    tap(57900, A('bP'), A('bP'));
    tl.to(A('dc1'), 58900, 500, { o: 0, y: -6 }, SOFT);
    tl.init(A('dc2'), { y: 6 }).to(A('dc2'), 59100, 900, { o: 1, y: 0 }, OUT);
    tl.to(A('bF'), 58900, 450, { o: 0 }, SOFT).to(A('bP'), 58900, 450, { o: 0 }, SOFT).to(A('bR'), 59200, 800, { o: 1 }, SOFT);
    tl.to(A('tP'), 59200, 800, { o: 1, y: 0 }, OUT).to(A('tP'), 61700, 500, { o: 0, y: -10 }, SOFT);

    /* 8 · Y así cada 3 meses */
    tl.to(A('ph'), 63500, 700, { o: 0, s: .95, x: PX + 145 * .05, y: TOP + 300 * .05 }, SOFT).to(A('fade'), 63500, 600, { o: 0 }, SOFT);
    tl.init(A('w4'), { y: 12 }).to(A('w4'), 64200, 1500, { o: 1, y: 0 }, OUT);
    ends.forEach(function (e, i) { tl.to(e, 64700 + i * 240, 1100, { o: 1, y: 0 }, OUT) });
    ['k0', 'k1', 'k2', 'k3'].forEach(function (r, j) { tl.init(A(r), { y: 10 }).to(A(r), 65800 + j * 220, 1000, { o: 1, y: 0 }, OUT) });

    /* barra de progreso: avanza seguida, a ritmo constante, de principio a fin (un solo transform en el compositor) */
    var pr = this.root.querySelector('[data-rc-prog]');
    if (pr) tl.init(pr, { sx: .002 }).to(pr, 0, 70000, { sx: 1 }, LIN);

    this.anims = tl.build();
    this.T = 70000;
    this.anims[0].onfinish = function () { self.end() };
  };

  /* ---------- reproducción ---------- */
  Film.prototype.now = function () { return this.anims.length ? (this.anims[0].currentTime || 0) : 0 };
  Film.prototype.seek = function (t) { this.anims.forEach(function (a) { a.currentTime = t }); this.ui(t) };
  Film.prototype.play = function () {
    if (!this.anims.length) return;
    if (this.now() >= this.T - 1) this.seek(0);
    this.playing = true; this.done = false; this.root.classList.remove('is-end'); this.root.classList.add('is-play');
    this.anims.forEach(function (a) { a.play() }); this.tick();
  };
  Film.prototype.pause = function () { this.playing = false; this.root.classList.remove('is-play'); this.anims.forEach(function (a) { a.pause() }); clearTimeout(this.raf) };
  Film.prototype.end = function () { this.playing = false; this.done = true; this.root.classList.remove('is-play'); this.root.classList.add('is-end'); clearTimeout(this.raf); this.ui(this.T) };
  /* sin bucle por fotograma: un temporizador hasta el siguiente cambio de capítulo */
  Film.prototype.tick = function () {
    var self = this; clearTimeout(this.raf); if (!this.playing) return;
    var t = this.now(), nx = this.T; this.ui(t);
    this.root.querySelectorAll('[data-rc-go]').forEach(function (b) { [+b.getAttribute('data-from'), +b.getAttribute('data-to')].forEach(function (v) { if (v > t + 5 && v < nx) nx = v }) });
    this.raf = setTimeout(function () { self.tick() }, Math.max(60, nx - t + 30));
  };
  /* capítulo activo (los botones de debajo) */
  Film.prototype.ui = function (t) {
    var on = null; this.root.querySelectorAll('[data-rc-go]').forEach(function (b) {
      var a = +b.getAttribute('data-from'), z = +b.getAttribute('data-to'), hit = t >= a && t < z;
      if (hit) on = b; if (b.__on !== hit) { b.__on = hit; b.classList.toggle('is-on', hit); b.setAttribute('aria-current', hit ? 'true' : 'false') }
    });
  };

  function init(root) {
    var cj = root.querySelector('[data-k4r-cfg]'); if (!cj) return;
    var cfg; try { cfg = JSON.parse(cj.textContent) } catch (e) { return }
    var F = new Film(root, cfg);
    root.__film = F;
    var CH = { mezcla: [27000, 45000], fecha: [45000, 57000], pausa: [57000, 63500], final: [63500, 70001] };
    root.querySelectorAll('[data-rc-go]').forEach(function (b) { var r = CH[b.getAttribute('data-rc-go')] || CH.mezcla; b.setAttribute('data-from', r[0]); b.setAttribute('data-to', r[1]) });
    var rebuild = function (handles) {
      var t = F.anims.length ? F.now() : (RM ? 5000 : 0), was = F.playing;
      if (!F.build(handles)) return;
      F.seek(t); if (was) F.play();
    };
    rebuild(window.__k4sel && window.__k4sel.handles);
    root.classList.add('is-ready');
    var last = JSON.stringify(window.__k4sel && window.__k4sel.handles || []);
    document.addEventListener('k4:sel', function (e) { var k = JSON.stringify(e.detail && e.detail.handles || []); if (k != last) { last = k; rebuild(e.detail.handles) } });
    if ('ResizeObserver' in window) new ResizeObserver(function () { F.scale() }).observe(F.st); else window.addEventListener('resize', function () { F.scale() });

    /* botones: saltan a la escena y la reproducen (con movimiento reducido, saltan al final de la escena sin moverse) */
    root.querySelectorAll('[data-rc-go]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = +b.getAttribute('data-from'), z = +b.getAttribute('data-to');
        if (RM) { F.seek(Math.min(z, F.T) - 400); F.ui(a); return }
        F.seen = true; F.seek(a); F.play();
      });
    });
    var again = root.querySelector('[data-rc-again]'); if (again) again.addEventListener('click', function () { F.seen = true; F.seek(0); F.play() });
    F.st.addEventListener('click', function () { if (RM) return; if (F.playing) { F.pause(); root.classList.add('is-hold') } else { root.classList.remove('is-hold'); F.play() } });

    if (RM) { root.classList.add('is-rm', 'is-end'); return }
    /* arranca al verse; fuera de pantalla se para; al volver sigue (salvo que la haya parado ella) */
    if (!('IntersectionObserver' in window)) { F.play(); return }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.intersectionRatio >= .45) { if (!F.done && !F.playing && !root.classList.contains('is-hold')) F.play() }
        else if (en.intersectionRatio < .15 && F.playing) F.pause();
      });
    }, { threshold: [0, .15, .45, .7] }).observe(F.st);
  }

  function boot() { document.querySelectorAll('[data-k4r]').forEach(function (r) { if (!r.__k4r) { r.__k4r = 1; init(r) } }) }
  if (document.readyState == 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
